// src/pages/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {

  return (
    <>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
        <p className="mb-2">Last updated: <span className="font-semibold">02-10-2024</span></p>

        <p className="mb-4">Indeecast ("us", "we", or "our") operates audiometa.indeecast.com (the "Site"). This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Information Collection And Use</h2>
        <p className="mb-4">While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Log Data</h2>

        <p className="mb-4">Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Cookies</h2>

        <p className="mb-4">Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>

        <p>Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Security</h2>

        <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Changes To This Privacy Policy</h2>

        <p>This Privacy Policy is effective as of 02-10-2024 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p>

        <p className="mb-4">We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>

        <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us.</p>
      </div>

    </>
  );
};

export default PrivacyPolicy;
